import { runClientComponent } from '../../_common/client/client-component-runner';
import { SponsoredContentAndPromotionsComponent } from './sponsored-content-and-promotions.component';

runClientComponent({ SponsoredContentAndPromotionsComponent });
